import DTO from './DTO';

class OsgopDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'carrier_external_id',
        type: String,
        validators: [],
        labelKey: 'carrier.external_id',
      },
      {
        name: 'vehicle_osgop_number',
        type: String,
        validators: [],
        labelKey: 'osgop_insurance_contract_number',
      },
      {
        name: 'vehicle_osgop_valid_from_date',
        type: String,
        validators: [],
        labelKey: 'osgop_insurance_contract_effective_date',
      },
      {
        name: 'vehicle_osgop_valid_until_date',
        type: String,
        validators: [],
        labelKey: 'osgop_insurance_contract_expiration_date',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default OsgopDTO;
